(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
                               this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucira-showcase-with-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('productsGrid');
  const checks = document.querySelectorAll('.filter-checkbox');

  function applyFilters() {
    const active = { ringSize: [], shopFor: [], weight: [], diamondShape: [], gemstoneShape: [], material: [], category: [], purity: [], design: [], finishing: [], fit: [], price: {}, carat: {} };

    checks.forEach(cb => {
      if (cb.checked) active[cb.dataset.filterType].push(cb.value);
    });

    active.price.min = Number(document.getElementById('price-min').value);
    active.price.max = Number(document.getElementById('price-max').value);
    active.carat.min = Number(document.getElementById('carat-min').value);
    active.carat.max = Number(document.getElementById('carat-max').value);

    grid.querySelectorAll('.product-card').forEach(card => {
      let show = true;

      ['ringSize','shopFor','weight','diamondShape','gemstoneShape','material','category','purity','design','finishing','fit'].forEach(type => {
        if (active[type].length) {
          const values = (card.dataset[type.toLowerCase().replace('shape','shape').replace('for','for')] || '').split(',').map(v => v.trim());
          if (!active[type].some(v => values.includes(v))) show = false;
        }
      });

      const price = Number(card.dataset.price || 0);
      if (price < active.price.min || price > active.price.max) show = false;

      const carat = Number(card.dataset.carat || 0);
      if (carat < active.carat.min || carat > active.carat.max) show = false;

      card.classList.toggle('hidden', !show);
    });
  }

  checks.forEach(cb => cb.addEventListener('change', applyFilters));

  // Price & Carat sliders
  document.getElementById('price-min').addEventListener('input', () => {
    document.getElementById('min-price').textContent = '₹' + Number(document.getElementById('price-min').value).toLocaleString('en-IN');
    applyFilters();
  });
  document.getElementById('price-max').addEventListener('input', () => {
    document.getElementById('max-price').textContent = '₹' + Number(document.getElementById('price-max').value).toLocaleString('en-IN');
    applyFilters();
  });
  document.getElementById('carat-min').addEventListener('input', () => {
    document.getElementById('min-carat').textContent = Number(document.getElementById('carat-min').value).toFixed(1);
    applyFilters();
  });
  document.getElementById('carat-max').addEventListener('input', () => {
    document.getElementById('max-carat').textContent = Number(document.getElementById('carat-max').value).toFixed(1);
    applyFilters();
  });

  // Accordion
  document.querySelectorAll('.filter-header').forEach(header => {
    header.addEventListener('click', () => {
      const content = document.getElementById(header.dataset.toggle);
      const isOpen = header.classList.contains('active');

      document.querySelectorAll('.filter-header').forEach(h => {
        if (h !== header) {
          h.classList.remove('active');
          document.getElementById(h.dataset.toggle).style.display = 'none';
          h.querySelector('.toggle-icon').textContent = '+';
        }
      });

      if (isOpen) {
        header.classList.remove('active');
        content.style.display = 'none';
        header.querySelector('.toggle-icon').textContent = '+';
      } else {
        header.classList.add('active');
        content.style.display = 'block';
        header.querySelector('.toggle-icon').textContent = '−';
      }
    });
  });

  // Swatches + Variant to Cart
  function initSwatches() {
    document.querySelectorAll('.color-swatches').forEach(container => {
      const swatches = container.querySelectorAll('.swatch');
      const card = container.closest('.product-card');
      const variantInput = card.querySelector('.variant-input');

      swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          swatches.forEach(s => s.classList.remove('active'));
          this.classList.add('active');

          const mainImg = card.querySelector('.main-img');
          const hoverImg = card.querySelector('.hover-img');

          if (mainImg) mainImg.src = this.dataset.image;
          if (hoverImg) hoverImg.src = this.dataset.hoverImage || this.dataset.image;

          if (variantInput) variantInput.value = this.dataset.variantId;
        });
      });

      if (swatches.length > 0) swatches[0].click();
    });
  }

  initSwatches();

  const origApply = applyFilters;
  applyFilters = function() {
    origApply.call(this);
    setTimeout(initSwatches, 80);
  };
});

  } catch(e) { console.error(e); }
})();
})();
